import ErrorIndicator from './ErrorIndicator';

export default ErrorIndicator;

//TODO POINT
// It's content for ErrorBoundary component
// You can use it as a sample as default
// You can modify it to suit your needs
// This component is used in ErrorBoundary.tsx
